var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAndroid2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_19_3216)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_19_3216)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_3216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 8H8V32H32V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_3216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 26V29C19 29.55 18.55 30 18 30C17.45 30 17 29.55 17 29V26H19Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 26V29C23 29.55 22.55 30 22 30C21.45 30 21 29.55 21 29V26H23Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 19V24C25 25.1 24.1 26 23 26H17C15.9 26 15 25.1 15 24V19C15 17.9 15.9 17 17 17H23C24.1 17 25 17.9 25 19Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 19V23C13 23.55 12.55 24 12 24C11.45 24 11 23.55 11 23V19C11 18.45 11.45 18 12 18C12.55 18 13 18.45 13 19Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 19V23C29 23.55 28.55 24 28 24C27.45 24 27 23.55 27 23V19C27 18.45 27.45 18 28 18C28.55 18 29 18.45 29 19Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 15.6H22.4C23.28 15.6 24 14.88 24 14C24 11.79 22.21 10 20 10C17.79 10 16 11.79 16 14C16 14.88 16.72 15.6 17.6 15.6Z",
    fill: "#34D399"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_3216",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19_3216",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 34.7917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAndroid2);
export default __webpack_public_path__ + "static/media/icon-android2.daa18c578993a41a3457c7c367ce7c1c.svg";
export { ForwardRef as ReactComponent };